import React from 'react';
import { services } from '../../data/services';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const Intercom = () => {
  const intercomService = services.find(service => service.title === "Intercom");

  return (
    <>
      <Hero
        title="Sisteme de Interfon"
        subtitle="Soluții moderne de interfonie pentru blocuri și complexe rezidențiale"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-intercom.jpg"
        icon={intercomService?.icon}
        iconLabel={intercomService?.title}
      />

      {intercomService && (
        <ServiceSection
          service={intercomService}
          index={0}
          pricingFirst
          id="tarife"
          backgroundImage={false}
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Intercom;
